import { useState } from 'react';
import { useForm } from 'react-hook-form';

const AddProduct = () => {
    const [fileName, setFileName] = useState('no file chosen');
    const {register, handleSubmit, formState: { errors }, reset} = useForm();

    const addProductHandler = (data) => {
        console.log(data);
    }

    return (
        <div className="container mx-auto px-2 xl:px-20 my-10">
            <form className="flex flex-col space-y-4" onSubmit={handleSubmit(addProductHandler)}>
                <h1 className="text-xl font-semibold text-gray-700 mb-5">Add New Product in <span className="text-3xl text-[#e74c3c]">Stock!</span></h1>
                <div className="sm:flex sm:space-x-4 space-y-2 sm:space-y-0">
                    <div className="flex flex-1 flex-col space-y-2">
                        <label htmlFor="" className="text-sm font-medium text-gray-700">Product Name</label>
                        <input className="border border-gray-400 text-sm text-gray-400 rounded-md p-2" type="text" {...register("productName", { required: true })} placeholder="Product Name" />
                        {errors.productName && <span className='text-sm text-red-500'>This field is required</span>}
                    </div>
                    <div className="flex flex-1 flex-col space-y-2">
                        <label htmlFor="" className="text-sm font-medium text-gray-700">Purchase Price</label>
                        <input type="text" className="border border-gray-400 text-sm text-gray-400 rounded-md p-2" {...register("productPrice", { required: true })} placeholder="Product Price" />
                        {errors.productPrice && <span className='text-sm text-red-500'>This field is required</span>}
                    </div>
                </div>
                <div className="sm:flex sm:space-x-4 space-y-2 sm:space-y-0">
                    <div className="flex flex-1 flex-col space-y-2">
                        <label htmlFor="salesPrice" className="text-sm font-medium text-gray-700">Sales Price</label>
                        <input type="text" id='salesPrice' className="border border-gray-400 text-sm text-gray-400 rounded-md p-2" {...register("salesPrice", { required: true })} placeholder="Sales Price" />
                        {errors.salesPrice && <span className='text-sm text-red-500'>This field is required</span>}
                    </div>
                    <div className="flex flex-1 flex-col space-y-2">
                        <label htmlFor="" className="text-sm font-medium text-gray-700">Brand Name</label>
                        <input type="text" className="border border-gray-400 text-sm text-gray-400 rounded-md p-2" {...register("brandName", { required: true })} placeholder="Brand Name" />
                        {errors.brandName && <span className='text-sm text-red-500'>This field is required</span>}
                    </div>
                </div>
                <div className="sm:flex sm:space-x-4 space-y-2 sm:space-y-0">
                    <div className="flex flex-1 flex-col space-y-2">
                        <label htmlFor="" className="text-sm font-medium text-gray-700">Category</label>
                        <select id="product-category" {...register("productCategory", { required: true })} className="border border-gray-400 text-sm text-gray-400 rounded-md p-2">
                            <option value="">Select Category</option>
                            <option value="oil">Oil</option>
                            <option value="rice">Rice</option>
                            <option value="vegetable">Vegetable</option>
                        </select>
                        {errors.productCategory && <span className='text-sm text-red-500'>This field is required</span>}
                    </div>
                    <div className="flex flex-1 flex-col space-y-2">
                        <label htmlFor="" className="text-sm font-medium text-gray-700">Supplier Name</label>
                        <input type="text" className="border border-gray-400 text-sm text-gray-400 rounded-md p-2" {...register("supplierName", { required: true })} placeholder="supplier name" />
                        {errors.supplierName && <span className='text-sm text-red-500'>This field is required</span>}
                    </div>
                </div>
                <div>
                    <label htmlFor="" className="text-sm font-medium text-gray-700">Bar Code</label>
                    <div className="flex gap-x-2 mt-3">
                        <input type="text" className="w-8/12 sm:w-11/12 border border-gray-400 text-sm text-gray-400 rounded-md p-2" {...register("supplierName", { required: true })} placeholder="barcode number" />
                        <button type='button' className='w-4/12 sm:w-1/12 p-3 bg-slate-400 rounded-md flex justify-center'>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                <path d="M2 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V4zM8 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1H9a1 1 0 01-1-1V4zM15 3a1 1 0 00-1 1v12a1 1 0 001 1h2a1 1 0 001-1V4a1 1 0 00-1-1h-2z" />
                            </svg>
                        </button>
                    </div>
                    {errors.supplierName && <span className='text-sm text-red-500'>This field is required</span>}
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700"> Product Photo </label>
                    <div className="w-full mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                        <div className="w-full space-y-1 text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                            <div className="w-full text-sm text-gray-600">
                                <label htmlFor="file-upload" className="inline relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none">
                                    <span>Upload a file</span>
                                    <input id="file-upload" type="file" {...register("productImage", { required: true })} onChange={(e)=>{setFileName(e.target.files[0].name)}} className="sr-only"/>
                                </label>
                                <p className="pl-1 lg:inline truncate">{fileName}</p>
                            </div>
                            <p className="text-xs text-gray-500">PNG, JPG, GIF up to 10MB</p>
                        </div>
                    </div>
                    {errors.productImage && <span className='text-sm text-red-500'>This field is required</span>}
                </div>
                <div className="flex space-x-6 pt-4 justify-center">
                    <button type='submit' className="w-4/12 btn btn-sm bg-[#303640]">Save</button>
                    <button type='button' onClick={()=>reset()} className="w-4/12 btn btn-sm bg-[#F87272]">Reset</button>
                </div>
            </form>
        </div>
    );
};

export default AddProduct;